<template>
  <b-modal 
    centered 
    :id="'select-company-modal'+idModal" 
    title="Выбор компании" 
    class="modal-primary" 
    size="md"
    header-bg-variant="primary"
    ok-only
    :ok-disabled="$v.$invalid"
    @ok="$emit('okClick', idCompany)"
  >
    <b-card>
      <b-input-group class="mr-2 mb-2" prepend="Компания">
        <b-form-select :options="companies" v-model="idCompany"></b-form-select>
        <b-overlay :show="tableCompaniesBusy" no-wrap></b-overlay>
      </b-input-group> 
    </b-card>
  </b-modal>
</template>

<script>   
    import { validationMixin } from "vuelidate"
    import { required, minLength, email, sameAs, helpers,  } from "vuelidate/lib/validators" 
    import CompaniesService from '@/services/web/companies.service'

export default {
  name: 'select-company-modal',
  components: { },
  props: {
    value: {
      type: String,
    },
  },

  data: function() {
    return {
      idModal: '',
      companies: [],
      tableCompaniesBusy: false
    }
  },

  computed: {
    idCompany: {
      get() {        
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
  },

  mixins: [validationMixin],

  validations: {
    idCompany: {
      required
    }
  },

  methods: {
    show(show) {
      if (show) {
        this.$bvModal.show('select-company-modal' + this.idModal)
      }
      else {
        this.$bvModal.hide('select-company-modal' + this.idModal)
      }
    },

    getCompanies() {
      this.tableCompaniesBusy = true
      CompaniesService.get(null, null, null, 1, 100)
      .then(response  => {
        if (response.data != null && response.data.data != null) {
          this.tableCompaniesBusy = false

          response.data.data.forEach(e => this.companies.push({text: e.name, value: e.id}))
        }
      }).catch( exc => {
        this.tableCompaniesBusy = false
        console.log('Error getCompanies() ' + exc)
      })
    },
  },

  mounted() {
    this.idModal = String(Math.random()) // crypto.randomUUID()
    this.getCompanies()
   }
}
</script>
 
 